import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2007"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M6.998 4.863a.701.701 0 0 0-1.213.701L6.787 7.3H4.782a.7.7 0 1 0 0 1.4h2.005l-1.002 1.736a.701.701 0 0 0 1.213.701L8 9.401l1.002 1.736a.7.7 0 0 0 .956.256.701.701 0 0 0 .257-.957L9.213 8.7h2.005a.7.7 0 1 0 0-1.4H9.213l1.002-1.736a.701.701 0 0 0-1.213-.701L8 6.599 6.998 4.863z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M14.649 3.743 8.35.095a.693.693 0 0 0-.701 0L1.351 3.743A.705.705 0 0 0 1 4.352v7.296c0 .251.134.483.351.609l6.298 3.648a.688.688 0 0 0 .701 0l6.298-3.648a.703.703 0 0 0 .352-.609V4.352a.705.705 0 0 0-.351-.609zm-1.052 7.499L8 14.484l-5.597-3.242V4.759L8 1.516l5.597 3.242v6.484z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }